
<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">


  <div class="legend">
    <span class="legend-text"># of Medicare Beneficiaries</span>
    <div class="legend-label">
      <div class="color-square" [style.background-color]="'#F0ECAB'"></div>
      <span>31 - 20,553</span>
    </div>
    <div class="legend-label">
      <div class="color-square" [style.background-color]="'#C9BC87'"></div>
      <span>20,554 - 45,704</span>
    </div>
    <div class="legend-label">
      <div class="color-square" [style.background-color]="'#C9BC87'"></div>
      <span>45,705 - 77,199</span>
    </div>
    <div class="legend-label">
      <div class="color-square" [style.background-color]="'#856C49'"></div>
      <span>77,200 - 122,538</span>
    </div>
    <div class="legend-label">
      <div class="color-square" [style.background-color]="'#664830'"></div>
      <span>122,539 - 242,193</span>
    </div>
    <div class="legend-label">
      <div class="color-square" [style.background-color]="'#444'"></div>
      <span>No Data</span>
    </div>
  </div>
</tgrid-layer-header>
